import { createFileRoute } from "@tanstack/react-router";
import { IaPage } from "@/components/pages/IaPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Kentro AIs — Try the AI for your industry now | Kentro Sistemas",
    desc: "Chat now with AIs trained by niche: pharmacy, clinic, sales, university, e-commerce, hotel, gym, ISP and more. Free test in under 30 seconds.",
    ogTitle: "Kentro AIs — Try the AI for your industry now",
    ogDesc: "10 niche-trained AIs ready to chat. See how Kentro serves, qualifies and sells 24/7.",
  },
  es: {
    title: "IAs Kentro — Prueba ya la IA de tu sector | Kentro Sistemas",
    desc: "Conversa ya con IAs entrenadas por nicho: farmacia, clínica, ventas, universidad, e-commerce, hotel, gimnasio, ISP y más. Prueba gratis en menos de 30 segundos.",
    ogTitle: "IAs Kentro — Prueba ya la IA de tu sector",
    ogDesc: "10 IAs entrenadas por nicho, listas para conversar. Mira cómo Kentro atiende, califica y vende 24/7.",
  },
} as const;

export const Route = createFileRoute("/$locale/ia")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/ia` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/ia` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/ia` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/ia` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/ia` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/ia` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'IAs Kentro', item: `${SITE}/${loc}/ia` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/ia`,
            url: `${SITE}/${loc}/ia`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: IaPage,
});
